<template lang="">
  <div>
    <iframe
      :src="url"
      frameborder="0"
      id="myiframe"
      width="100%"
      allowtransparency
      v-iframe-resize="{ log: true }"
    ></iframe>
  </div>
</template>
<script>
import { dashboardUrl } from "@/helpers/dashboards";
export default {
  data() {
    return {
      url:
        dashboardUrl("entreprise") +
        "?code_client=" +
        this.$store.state.entreprise.code_fta +
        "#hide_parameters=code_client",
    };
  },
};
</script>
<style lang=""></style>
